export const hasClass = (el, className) => {
    if (el.classList) {
        return el.classList.contains(className);
    } else {
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
    }
}

export const removeClass = (el, className) => {
    if (el.classList) {
        el.classList.remove(className);
    } else {
        el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
}

export const addClass = (el, className) => {
    if (el.classList) {
        el.classList.add(className);
    } else {
        var current = el.className, found = false;
        var all = current.split(' ');
        for (var i=0; i<all.length, !found; i++) found = all[i] === className;
        if (!found) {
            if(current === '') el.className = className;
            else el.className += ' ' + className;
        }
    }
}